/* -----------------Third parties--------------- */
import { useAppTheme } from "../../../useAppTheme";

/* -----------------UI--------------- */
import { TouchableRipple } from "react-native-paper";

/* -----------------Third parties--------------- */
import * as Animatable from "react-native-animatable";

import { Confidence } from "@memorang/types";
import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------Components--------------- */
import type { IconType } from "../../../icon";
import Container from "../../Container";

/* -----------------Props--------------- */
type Props = {
	handleConfidenceProvided: (confidence: Confidence) => void;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
};
const confidenceIcons: Record<string, IconType> = {
	low: "emoticon-sad-outline",
	medium: "emoticon-neutral-outline",
	high: "emoticon-happy-outline",
};

const SubmitAnswerStatic = (props: Props) => {
	const { handleConfidenceProvided, handleTrackConfidenceClick } = props;
	const theme = useAppTheme();

	const handleSubmitConfidence = (selectedConfidence: Confidence) => {
		handleTrackConfidenceClick(selectedConfidence);
		handleConfidenceProvided(selectedConfidence);
	};
	return (
		<Container maxWidth="sm">
			<Animatable.View
				useNativeDriver
				style={{
					flexDirection: "row",
					gap: 16,
					alignItems: "flex-start",
				}}
				duration={300}
				animation="fadeIn"
				easing="ease-out"
			>
				{(Object.keys(confidenceIcons) as (keyof typeof Confidence)[]).map(
					(c) => {
						const Content = () => {
							return (
								<TouchableRipple
									key={c}
									onPress={() => handleSubmitConfidence(Confidence[c])}
									style={{
										display: "flex",
										backgroundColor: theme.palette.confidence[c],
										borderRadius: 24,
										overflow: "hidden",
										justifyContent: "center",
										alignItems: "center",
										height: 40,
										flex: 1,
										width: "100%",
									}}
									accessibilityLabel={`Confidence level ${c}`}
									accessibilityRole="button"
									testID={`confidence-button-${c}`}
								>
									<Icon name={confidenceIcons[c]} size={24} color="white" />
								</TouchableRipple>
							);
						};
						return <Content key={c} />;
					},
				)}
			</Animatable.View>
		</Container>
	);
};

export default SubmitAnswerStatic;
